export function backlogFulfillmentValidate(backlog_fulfillment) {
     var result = true; 
    var errors = [];

    result = validateFulfillment(backlog_fulfillment.fulfillment, errors);
    if(!result) return errors;
    
    else return result;
}

function validateFulfillment(fulfillment, errors) {
    if (Array.isArray(fulfillment)  
     && fulfillment.every(item =>
        typeof item === 'object' &&
        item !== null &&

        typeof item.client_name === "string" &&
        item.client_name !== '' &&

        typeof item.cutoff_time === "string" &&
        item.cutoff_time !== '' &&

        typeof item.type === "string" &&
        item.type !== '' &&
        
        typeof item.in_time === 'number' &&
        !isNaN(item.in_time) &&

        typeof item.late === 'number' &&
        !isNaN(item.late) &&

        typeof item.processed === 'number' &&
        !isNaN(item.processed) &&

        typeof item.without_stock === 'number' &&
        !isNaN(item.without_stock)         
    )) return true;
    else {
        errors.push("backlog_fulfillment_fulfillment_not_valid")
        return false;
    }   
}